module.exports = __webpack_public_path__ + "static/media/liveSetup.f949b004.png";